/**
 * layoutRegistry.js
 *
 * Maps every layout_type string to its corresponding @react-pdf/renderer component.
 *
 * To add a new template layout:
 *   1. Create the layout component (e.g., SleekLayoutPdf.jsx) accepting { model }.
 *   2. Add one line here: sleek: SleekLayout
 *   3. Done — no other files need to change.
 */

import ClassicLayout from "./ClassicLayoutPdf";
import GstLayout from "./GstLayoutPdf";
import MinimalLayout from "./MinimalLayoutPdf";
import ModernLayout from "./ModernLayoutPdf";
import TallyLayout from "./TallyLayoutPdf";

/**
 * Registry of all supported layout types.
 * Keys must match the `layout_type` field stored in the template record.
 */
const LAYOUT_REGISTRY = {
  classic: ClassicLayout,
  gst: GstLayout,
  minimal: MinimalLayout,
  modern: ModernLayout,
  tally: TallyLayout,
};

/**
 * Returns the layout component for the given layout type.
 * Falls back to ClassicLayout if the type is unknown.
 *
 * @param {string} layoutType
 * @returns {React.ComponentType}
 */
export const getLayoutComponent = (layoutType) =>
  LAYOUT_REGISTRY[layoutType] ?? LAYOUT_REGISTRY.classic;

/**
 * Returns all registered layout type keys.
 * Useful for building template-type pickers in the UI.
 *
 * @returns {string[]}
 */
export const getSupportedLayouts = () => Object.keys(LAYOUT_REGISTRY);
